import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let thread_id = useDataValue({
    viewPath: props.viewPath,
    context: 'thread',
    path: 'id',
  })
  return {
    variables: {
      id: thread_id,
    },
    pause: !thread_id,
  }
}
